import { Box } from '@mui/material'
import HelpOverlay from '@src/components/Onboarding/HelpOverlay'
import OnboardingTour from '@src/components/Onboarding/OnboardingTour'
import { Outlet } from 'react-router-dom'
import AppHeader from './AppHeader'

const TemplateGlobal = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <AppHeader />
      <OnboardingTour />
      <HelpOverlay />
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default TemplateGlobal
